import React, { useState } from "react";
import google from "../image/google.png";
import hirebeen from "../image/hirebeenLogo.png";
import hide from "../image/icons/hide.png";
import view from "../image/icons/view.png";
import H from "../image/H.png";
import Group1 from "../image/Group1.svg";
import Group2 from "../image/Group2.svg";
import Group3 from "../image/Group3.svg";
import { Link, Navigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { login } from "../reducer/Actions";
import { toast } from "react-toastify";
import CustomButton from "../Reusable/CustomButton";
import axios from "axios";
import { API_URL, CALLBACK_URL, GOOGLE_CLIENT_ID } from "../apiConfig";
import TYPE from "../reducer/Type";

const Login = ({ isAuthenticated, alertMessage }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState();
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);

  const [login, setLogin] = useState({
    email: "",
    password: "",
  });

  const [errMsg, setErrMsg] = useState({
    email: "",
    password: "",
    isEmailValid: true,
    isPasswordValid: true,
  });

  const handleLogin = async () => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      // Need to check use of body to stringify
      const body = JSON.stringify({
        email: login.email,
        password: login.password,
      });
      setLoading(true);
      const res = await axios.post(
        `${API_URL}/dj-rest-auth/login/`,
        body,
        config
      );
      setLoading(false);

      dispatch({
        type: TYPE.LOGIN_SUCCESS,
        payload: res.data,
      });

      if (res?.statusText === "OK") {
        toast.success("User logged in successfully", {
          autoClose: 1500,
        });
      } else {
        toast.error("Something went wrong. Pleast try again later.", {
          autoClose: 1500,
        });
      }
      setLogin({
        email: "",
        password: "",
      });

      return;
    } catch (err) {
      dispatch({
        type: TYPE.LOGIN_FAIL,
      });
      toast.error(err?.response?.data?.non_field_errors[0], {
        autoClose: 2500,
      });
      setLoading(false);
      return;
    }
  };

  const reachGoogle = () => {
    const clientID = GOOGLE_CLIENT_ID;
    const callBackURI = CALLBACK_URL;
    window.location.replace(
      `https://accounts.google.com/o/oauth2/v2/auth?redirect_uri=${callBackURI}&prompt=consent&response_type=code&client_id=${clientID}&scope=openid%20email%20profile&access_type=offline`
    );
  };

  if (isAuthenticated) {
    console.log(alertMessage);
    return <Navigate to={"../Dashboard"}></Navigate>;
  }

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setLogin((prev) => ({ ...prev, email }));

    // Validate email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setErrMsg((prev) => ({ ...prev, email: "", isEmailValid: true }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        email: "Please enter a valid email.",
        isEmailValid: false,
      }));
    }
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setLogin((prev) => ({ ...prev, password }));

    // Validate password
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;
    if (passwordRegex.test(password)) {
      setErrMsg((prev) => ({ ...prev, password: "", isPasswordValid: true }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        password: "Please enter a valid password.",
        isPasswordValid: false,
      }));
    }
  };

  const disableLoginBtn = () => {
    return (
      !login.email ||
      !login.password ||
      !errMsg.isEmailValid ||
      !errMsg.isPasswordValid
    );
  };

  return (
    <div className="grid grid-cols-2 gap-0 max-md:grid-cols-1 ">
      <div className="block w-full h-full bg-conic-gradient max-md:hidden ">
        <div className="flex gap-2.5 self-start max-md:pr-5 mt-6 ml-6">
          <img
            loading="lazy"
            alt="H"
            src={H}
            className="shrink-1 aspect-[0.75] w-[29px]"
          />
          <img
            loading="lazy"
            src={hirebeen}
            alt="Hirebeen"
            className="shrink-0 my-auto max-w-full aspect-[5.56] w-[146px]"
          />
        </div>
        <div className=" mx-9 mt-20 text-5xl font-bold text-white leading-[70px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full max-md:text-4xl max-md:leading-[68px]">
          Build your successful resume instantly using AI
        </div>
        <div className="z-10 self-center mt-3.5 max-w-full w-[574px]">
          
          <div className="flex gap-1 max-md:flex-col max-md:gap-0">
            
            <div className="flex flex-col w-11/12 max-md:ml-0 max-md:w-full">
            
              <div className="flex flex-col mt-16 grow max-md:mt-10">
                <img loading="lazy" alt="R2" src={Group2} className="w-full" />
                <img
                  loading="lazy"
                  alt="R3"
                  src={Group3}
                  className="w-full mt-5"
                />
              </div>
            </div>
            <div className="flex flex-col w-11/12 ml-5 max-md:ml-0 max-md:w-full">
              <div className="flex flex-col max-md:mt-6">
                <img loading="lazy" alt="R1" src={Group1} className="w-full " />
                <img
                  loading="lazy"
                  alt="R2"
                  src={Group3}
                  className="w-full mt-5"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-col items-center rounded mt-36 max-md:mt-10">
        <div>
          <div className="text-4xl font-semibold leading-10 tracking-tighter text-gray-900 max-md:mt-4 max-md:max-w-full">
            Log in
          </div>
          <div className="mt-3 text-slate-600 max-md:max-w-full">
            Welcome back! Please enter your details.
          </div>
        </div>

        <div  className="flex flex-col justify-start p-2 m-1 ">
          <div onClick={reachGoogle} className="w-full flex hover:cursor-pointer gap-3 justify-center px-4 py-2.5 mt-4 font-semibold bg-white rounded-lg border border-gray-300 border-solid shadow-sm text-slate-700 max-md:flex-wrap max-md:px-5">
            <img
              loading="lazy"
              src={google}
              alt="Google"
              class="shrink-0 w-6 aspect-square"
            />
            <div >Login with Google</div>
          </div>
          {/* <br /> */}

          <form className="w-full">
            <div className="flex flex-col gap-y-4">
              
              {/* Email */}
              <div>
                <label for="email" className="mb-2 text-base font-medium ">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  required
                  className={`w-full px-3 py-1 text-sm border rounded-md outline-none ${
                    !errMsg?.email ? "" : "border-red-500"
                  }`}
                  name="email"
                  placeholder="name@example.com"
                  value={login.email}
                  onChange={handleEmailChange}
                />
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.email && <span className="">{errMsg?.email}</span>}
                </p>
              </div>

              {/* Password */}
              <div>
                <label htmlFor="password" className="mb-2 font-medium">
                  Password
                </label>
                <div className="flex flex-wrap w-full px-3 py-1 border rounded-md">
                  <input
                    type={visible ? "text" : "password"}
                    id="password"
                    required
                    className={`flex-grow text-sm outline-none ${
                      !errMsg?.password ? "" : "border-red-500"
                    }`}
                    name="password"
                    placeholder="password ..."
                    value={login.password}
                    onChange={handlePasswordChange}
                  />
                  <div
                    onClick={() => setVisible(!visible)}
                    className="float-left cursor-pointer"
                  >
                    {visible ? (
                      <img src={view} alt="Hide" className="w-4 h-4" />
                    ) : (
                      <img src={hide} alt="View" className="w-4 h-4" />
                    )}
                  </div>
                  {/* {alertMessage && (
                <p className="text-red-500 text-xs mt-[-20px]">
                  {alertMessage}
                </p>
              )} */}
                </div>
                <p className="mt-2 text-xs text-red-500">
                  {errMsg?.password && (
                    <span className="">{errMsg?.password}</span>
                  )}
                </p>
              </div>
            </div>

            <br />
            <div className="flex gap-x-7">
              <div className="flex">
                <input
                  type="checkbox"
                  name=""
                  htmlFor="checkbox"
                  id="CheckBox"
                  className="mr-2 hover:cursor-pointer"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span
                  id="checkbox"
                  className="hover:cursor-pointer"
                  onClick={() => setRememberMe((e) => !e)}
                >
                  Remember for 30 days
                </span>
              </div>

              <div>
                <button className="text-purple-500 float-end">
                  <Link to={"../reset/password/"}>Forgot password</Link>
                </button>
              </div>
            </div>

            <div className="flex w-full">
              <CustomButton
                disabled={disableLoginBtn()}
                onClick={handleLogin}
                loading={loading}
                className="py-1 mt-4"
              >
                Login
              </CustomButton>
            </div>
          </form>
          <p className="text-base">
            Don't have any account ?{" "}
            <Link className="font-semibold text-violet-700" to={"../signup/"}>
              Signup
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.AuthReducer.isAuthenticated,
  };
};

export default connect(mapStateToProps, { login })(Login);
